"use client";

import React from "react";
import HoverNavReset from "@/themes/epona/common/header/HoverNavReset";
import { NavigationItem, type MenuTreeNode } from "./NavigationItem";

/**
 * Crystal desktop primary navigation — a thin, centered row of glass
 * hover-dropdown items. Each node is a `NavigationItem`; `HoverNavReset`
 * (shared) closes any open panel on route change.
 */
export function DesktopNavigation({
  primaryMenu,
  currentLanguage,
  navClassName = "flex items-center gap-7",
}: {
  primaryMenu: MenuTreeNode[];
  currentLanguage: "en" | "mm";
  navClassName?: string;
}) {
  if (!primaryMenu || primaryMenu.length === 0) return null;

  return (
    <HoverNavReset>
      <nav className={navClassName} aria-label="Primary">
        {primaryMenu.map((item) => (
          <NavigationItem
            key={item._id}
            item={item}
            currentLanguage={currentLanguage}
          />
        ))}
      </nav>
    </HoverNavReset>
  );
}

export default DesktopNavigation;
